document.addEventListener("DOMContentLoaded", function () {
  // Function to initialize variant lists
  function initVariantLists() {
    // Target only the variant list for the Adapter option
    const adapterList = document.querySelector('.swatch--gl[data-option-index="1"] ul.value');

    if (adapterList) {
      // Skip if already initialized
      if (adapterList.getAttribute("data-toggle-initialized")) return;

      const listItems = adapterList.querySelectorAll("li");

      // Only apply the functionality if there are more than 3 items
      if (listItems.length > 3) {
        // Hide all items beyond the first 3
        for (let i = 3; i < listItems.length; i++) {
          listItems[i].style.display = "none";
        }

        // Calculate how many items are hidden
        const hiddenCount = listItems.length - 3;

        // Copy classes from existing option buttons to match styling
        const existingItem = adapterList.querySelector("li");
        const existingButton = adapterList.querySelector(".swatch-anchor");
        const existingClasses = existingButton ? existingButton.className : "";

        // Create new list item to contain the button
        const newListItem = document.createElement("li");
        if (existingItem && existingItem.className) {
          newListItem.className = existingItem.className;
        }

        // Create the button with the count
        const showMoreButton = document.createElement("button");
        showMoreButton.textContent = "+" + hiddenCount;
        showMoreButton.classList.add("variant-toggle-btn");

        // Add same classes as other option buttons for consistent styling
        if (existingClasses) {
          showMoreButton.classList.add("globo-style--button");
          // Add any other classes that help with styling consistency
          const classes = existingClasses.split(" ");
          for (const cls of classes) {
            if (cls.includes("globo-detail-") || cls.includes("swatch-")) {
              showMoreButton.classList.add(cls);
            }
          }
        }

        showMoreButton.setAttribute("type", "button");
        showMoreButton.setAttribute("title", `Show ${hiddenCount} more options`);

        // Add the button as a list item
        newListItem.appendChild(showMoreButton);
        adapterList.appendChild(newListItem);

        // Toggle visibility when clicking the button
        showMoreButton.addEventListener("click", function () {
          const isExpanded = showMoreButton.textContent === "Show less";

          if (isExpanded) {
            // Hide items when collapsing
            for (let i = 3; i < listItems.length; i++) {
              listItems[i].style.display = "none";
            }
            showMoreButton.textContent = "+" + hiddenCount;
            showMoreButton.setAttribute("title", `Show ${hiddenCount} more options`);
          } else {
            // Show all items when expanding
            for (let i = 3; i < listItems.length; i++) {
              listItems[i].style.display = "";
            }
            showMoreButton.textContent = "Show less";
            showMoreButton.setAttribute("title", `Show fewer options`);
          }
        });

        // Mark as initialized
        adapterList.setAttribute("data-toggle-initialized", "true");
      }
    }

    // Also look for dynamically loaded adapter lists
    const allLists = document.querySelectorAll('.swatch--gl[data-option-index="1"] ul.value');
    allLists.forEach((list) => {
      if (!list.getAttribute("data-toggle-initialized") && list !== adapterList) {
        const items = list.querySelectorAll("li");
        if (items.length > 3) {
          // This is a newly added adapter list, initialize it
          initVariantLists();
        }
      }
    });
  }

  // Run on initial load
  initVariantLists();

  // Also watch for dynamic content changes
  // This helps with Shopify's section rendering and theme editor
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Look specifically for newly added adapter options
        const addedAdapter = Array.from(mutation.addedNodes).some((node) => {
          if (node.nodeType === 1) {
            // Element node
            return node.querySelector && node.querySelector('.swatch--gl[data-option-index="1"]');
          }
          return false;
        });

        if (addedAdapter) {
          initVariantLists();
        }
      }
    });
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, { childList: true, subtree: true });
});
